<article>
  <h3 class="warning">{{ header }}</h3>

  <mat-dialog-content> {{ message }} </mat-dialog-content>

  <mat-dialog-actions>
    <div class="flex-row flex-pad">
      <div>
        <button mat-button (click)="cancelAction()">Cancel</button>
        <button mat-button sd-color="neon-blue" (click)="confirmAction()">Continue</button>
      </div>
    </div>
  </mat-dialog-actions>
</article>
